import { render, staticRenderFns } from "./OnboardingProfilePage.vue?vue&type=template&id=5a2fdf16&scoped=true&"
import script from "./OnboardingProfilePage.vue?vue&type=script&lang=js&"
export * from "./OnboardingProfilePage.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingProfilePage.vue?vue&type=style&index=0&id=5a2fdf16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2fdf16",
  null
  
)

export default component.exports